
export default class DashImportacaoModel {
  id: number;
  bookingStatus: string;
  sequenciaInstrucaoEmbarque: string;
  sequenciaDoEmbarque: string;
  documentoCompra: string;
  item: number;
  codigoFornecedorSap: number;
  idSku: number;
  quantidadePedido: number;
  quantidadeEmbarque: number;
  unidadeMedida: string;
  dataRemessaEstatistica: Date;
  dataRemessa: Date;
  etd: Date;
  eta: Date;
  entradaEstoque: Date;
  previsaoEntradaEstoque: Date;
  mes: number;
  semana: number;
  desvioRecebimento: number;
  justificativa: string;
  causador: string;
  observacao: string;

  constructor(
    id: number,
    bookingStatus: string,
    sequenciaInstrucaoEmbarque: string,
    sequenciaDoEmbarque: string,
    documentoCompra: string,
    item: number,
    codigoFornecedorSap: number,
    idSku: number,
    quantidadePedido: number,
    quantidadeEmbarque: number,
    unidadeMedida: string,
    dataRemessaEstatistica: Date,
    dataRemessa: Date,
    etd: Date,
    eta: Date,
    entradaEstoque: Date,
    previsaoEntradaEstoque: Date,
    mes: number,
    semana: number,
    desvioRecebimento: number,
    justificativa: string,
    causador: string,
    observacao: string
  ) {
    this.id = id;
    this.bookingStatus = bookingStatus;
    this.sequenciaInstrucaoEmbarque = sequenciaInstrucaoEmbarque;
    this.sequenciaDoEmbarque = sequenciaDoEmbarque;
    this.documentoCompra = documentoCompra;
    this.item = item;
    this.codigoFornecedorSap = codigoFornecedorSap;
    this.idSku = idSku;
    this.quantidadePedido = quantidadePedido;
    this.quantidadeEmbarque = quantidadeEmbarque;
    this.unidadeMedida = unidadeMedida;
    this.dataRemessaEstatistica = dataRemessaEstatistica;
    this.dataRemessa = dataRemessa;
    this.etd = etd;
    this.eta = eta;
    this.entradaEstoque = entradaEstoque;
    this.previsaoEntradaEstoque = previsaoEntradaEstoque;
    this.mes = mes;
    this.semana = semana;
    this.desvioRecebimento = desvioRecebimento;
    this.justificativa = justificativa;
    this.causador = causador;
    this.observacao = observacao;
  }

  static toJson(estoqueBRF: DashImportacaoModel): string {
    return JSON.stringify(estoqueBRF);
  }

  static fromJson(json: object[]): DashImportacaoModel[] {
    return json.map((item: any) => {
      return new DashImportacaoModel(
        item["id"],
        item["bookingStatus"],
        item["sequenciaInstrucaoEmbarque"],
        item["sequenciaDoEmbarque"],
        item["documentoCompra"],
        item["item"],
        item["codigoFornecedorSap"],
        item["idSku"],
        item["quantidadePedido"],
        item["quantidadeEmbarque"],
        item["unidadeMedida"],
        item["dataRemessaEstatistica"],
        item["dataRemessa"],
        item["etd"],
        item["eta"],
        item["entradaEstoque"],
        item["previsaoEntradaEstoque"],
        item["mes"],
        item["semana"],
        item["desvioRecebimento"],
        item["justificativa"],
        item["causador"],
        item["observacao"]
      );
    });
  }

}
